module.exports = __webpack_public_path__ + "img/increment.ba2eb5ce.png";